import React, { useState, useCallback } from 'react';
import { Button, Sheet } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import SideConversationList from './SideConversationList';
import { getTranslatedText } from '@nile/components';
import { Tooltip } from 'react-clone-tippy';
import { injectIntl } from 'react-intl';

/**
 * Common button component for selecting side conversation templates
 * @param {Function} populateTemplate - Function to handle template selection
 * @param {string} className - Optional className for the button
 * @param {string} workItemId - Work item ID for API call
 * @param {string} module - Module type for API call
 * @param {object} selectedMailBox - Selected mailbox for API call
 */
const SideConversationTemplateButton = ({
  populateTemplate,
  className,
  intl,
  workItemId,
  module,
  selectedMailBox
}) => {
  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = useCallback(
    () => setSheetActive((active) => !active),
    []
  );

  return (
    <Tooltip
      title={getTranslatedText(intl, 'salesInbox.listView.sideConversations')}
      html={
        <div className="p5">
          {getTranslatedText(intl, 'salesInbox.listView.sideConversations')}
        </div>
      }
      delay={400}
      duration={250}
      position="top-start"
      inertia
      trigger="mouseenter"
      animation="shift"
      animateFill={false}
    >
      <Button
        plainSecondary
        id="actionSideConversationTemplates"
        onClick={toggleSheetActive}
        className={className}
        aria-label={getTranslatedText(
          intl,
          'salesInbox.listView.sideConversations'
        )}
      >
        <SVGIcon name="ReplyBubble" />
      </Button>
      <Sheet open={sheetActive} onClose={toggleSheetActive} zIndex={522}>
        <SideConversationList
          populateTemplate={populateTemplate}
          toggleSheetActive={toggleSheetActive}
          workItemId={workItemId}
          module={module}
          selectedMailBox={selectedMailBox}
        />
      </Sheet>
    </Tooltip>
  );
};

export default injectIntl(SideConversationTemplateButton);
